import React from 'react';
import AnimatedUsps from './AnimatedUsps';
import { ImportantIcon, SmileyIcon, HighFiveIcon, PerfectIcon } from './Icons';
import { jsx as _jsx } from "react/jsx-runtime";
var usps = [{
  icon: /*#__PURE__*/_jsx(ImportantIcon, {}),
  text: 'Keep work and life separate by using your work email'
}, {
  icon: /*#__PURE__*/_jsx(SmileyIcon, {}),
  text: '45M+ users around the world'
}, {
  icon: /*#__PURE__*/_jsx(HighFiveIcon, {}),
  text: '#1 visual collaboration tool on G2'
}, {
  icon: /*#__PURE__*/_jsx(PerfectIcon, {}),
  text: '99% of the Fortune 100 are customers'
}];
export default function EmotionalUsps() {
  return /*#__PURE__*/_jsx(AnimatedUsps, {
    usps: usps
  });
}